import PropTypes from "prop-types";
import React from "react";

import { createClassNameString } from "../utils";
import { getAutomationDataAttr } from "../../utils/automationUtils";
import { Text } from "../Text";
import { TextColors, TextTypes } from "../constants";

import "./styles.scss";

export const Radio = ({
  checked,
  className,
  label,
  labelClassName,
  name,
  onChange,
  onClick,
  radioClassName,
  testId,
  value,
  ...props
}) => {
  return (
    <label className={createClassNameString(["apti-CL apti-Radio--container", className])}>
      <input
        checked={checked}
        className={createClassNameString(["apti-Radio", !label && "no-label", radioClassName])}
        name={name}
        onChange={onChange}
        onClick={onClick}
        type="radio"
        value={value}
        {...getAutomationDataAttr(testId)}
        {...props}
      />
      {label && (
        <Text
          className={createClassNameString(["apti-Radio--label", labelClassName])}
          color={TextColors.grey}
          type={TextTypes.label}
        >
          {label}
        </Text>
      )}
    </label>
  );
};

const radioProps = {
  checked: PropTypes.bool.isRequired,
  children: PropTypes.string.isRequired,
  label: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
};

const radioDefaultValues = {
  checked: false,
  className: undefined,
  label: undefined,
  labelClassName: undefined,
  onClick: () => {},
  value: "",
};

Radio.propTypes = radioProps;
Radio.defaultProps = radioDefaultValues;
